import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Upload,
  Button,
  Switch,
  Select,
  Row,
  Col,
  Tabs,
  Flex,
  Modal,
  Space,
  Table,
  TableProps,
} from "antd";
import styles from "./genralTabContent.module.css";
import EquipmentPartListPopup from "./EquipmentPartListPopup";
import FacilityListPopup from "./FacilityListPopup";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

import CategorySelection from "./CategorySelection";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";

import {
  FetchCategoryList,
  assetTypes,
  fetchClientList,
  ModalList,
} from "../../redux/actions/action";

function GenralTabContent({
  generalDetails,
  onDetailsChange,
  assetsType,
  validationErrors,
  type,
  assetsList,
  form,
}) {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [isPartOfChecked, setIsPartOfChecked] = useState(false);
  const [isMainAssets, setIsMainAssets] = useState(false);
  const [isLocatedAtChecked, setIsLocatedAtChecked] = useState(false);

  const [partOfButtonText, setPartOfButtonText] = useState("Choose Equipment");

  const [locatedfButtonText, setLocatedfButtonText] =
    useState("Choose Facility");

  const [isQuipPartModal, setIsQuipPartModal] = useState(false);
  const [isFacilityModal, setIsFacilityModal] = useState(false);
  const [categoryListMain, setCategoryListMain] = useState([]);
  const [clientListMain, setClientListMain] = useState([]);
  const [selectFacility, setSelectFacility] = useState();
  const [selectEquipment, setSelectEquipment] = useState();
  const [mainAssetsValue, setMainAssetsValue] = useState();

  const [showAssetCategoriesList, setShowAssetCategoriesList] = useState(false);
  const [categories, setCategorties] = useState([]);

  const dispatch = useDispatch();

  const modalRes = useSelector((state) => {
    return state.user.modalRes;
  });

  const categoryList = useSelector((state) => {
    return state.user.categoryList;
  });

  const clientList = useSelector((state) => {
    return state.user.clientList;
  });

  useEffect(() => {
    dispatch(FetchCategoryList());
    dispatch(fetchClientList());
    dispatch(ModalList());
  }, []);

  const [modalData, setModalData] = useState([]);
  const [modalDataShow, setModalDataShow] = useState(false);

  useEffect(() => {
    if (modalRes.status === true) {
      setModalData(modalRes.data);
    }
  }, [modalRes]);

  useEffect(() => {
    if (type === "Update") {
      form.setFieldsValue({
        category: generalDetails.category,
        client: generalDetails.clientId,
      });
      if (generalDetails.locatedAtName) {
        setIsLocatedAtChecked(true);
        setLocatedfButtonText(generalDetails.locatedAtName);
      } else {
        setIsLocatedAtChecked(false);
        setLocatedfButtonText("Choose Facility");
      }

      if (generalDetails.partOfName) {
        setIsPartOfChecked(true);
        setPartOfButtonText(generalDetails.partOfName);
      } else {
        setIsPartOfChecked(false);
        setPartOfButtonText("Choose Equipment");
      }

      if (generalDetails.mainAsset) {
        setIsMainAssets(true);
      }
    }
  }, [generalDetails]);

  useEffect(() => {
    const categoryListArray = categoryList.map((category) => {
      return {
        value: category,
        label: category,
      };
    });
    setCategoryListMain(categoryListArray);
  }, [categoryList]);

  useEffect(() => {
    const clientListArray = clientList.map((client) => {
      return {
        value: client.clientid,
        label: client.clientname,
      };
    });
    setClientListMain(clientListArray);
  }, [clientList]);

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const showEquipModal = () => {
    setIsQuipPartModal(true);
  };
  const showFacilityModal = () => {
    setIsFacilityModal(true);
  };

  const handleCancel = () => {
    setIsQuipPartModal(false);
    setIsFacilityModal(false);
  };

  const setCategoryArray = (val) => {
    let _categories = [];

    if (val && categoryListMain && categoryListMain.length > 0)
      _categories = categoryListMain.filter((o) => o.value.includes(val));

    setCategorties(_categories);
  };

  const handleInputChange = (field, value) => {
    // setGeneralDetails((prevDetails) => ({
    //   ...prevDetails,
    //   [field]: value,
    // }));

    if (field === "mainAsset") {
      setMainAssetsValue(value);
    }

    onDetailsChange({ ...generalDetails, [field]: value });
  };

  const handleSelectEquipmentChange = (selectedEquipment, EquipmentName) => {
    if (selectedEquipment) {
      const updatedDetails = {
        ...generalDetails,
        partOf: selectedEquipment,
        partOfName: EquipmentName,
      };
      setSelectEquipment(selectedEquipment);
      onDetailsChange(updatedDetails);
      setPartOfButtonText(EquipmentName);
      generalDetails.partOfName = EquipmentName;
    } else {
      setPartOfButtonText("Choose Equipment");
    }
  };

  const handleFacilityChange = (selectFacility, facilityName) => {
    if (selectFacility) {
      let updatedDetails = {
        ...generalDetails,
      };
      if (assetsType === "Facility") {
        updatedDetails.partOf = selectFacility;
        updatedDetails.partOfName = facilityName;
        setPartOfButtonText(facilityName);
        // generalDetails.partOfName = facilityName;
      } else {
        updatedDetails.locatedAt = selectFacility;
        // generalDetails.locatedAt = facilityName;
        updatedDetails.locatedAtName = facilityName;
        setLocatedfButtonText(facilityName);
      }

      onDetailsChange(updatedDetails);
      setSelectFacility(selectFacility);
    } else {
      setLocatedfButtonText("Choose Facility");
    }
  };

  const handlePartChanges = (field) => {
    if (field === "partOf") {
      handleInputChange("mainAsset", "");

      if (!isPartOfChecked) {
        setIsPartOfChecked(true);
        setIsLocatedAtChecked(false);
        setIsMainAssets(false);

        // if (selectEquipment) {
        const updatedDetails = {
          ...generalDetails,
          partOfName: selectEquipment
            ? selectEquipment.name
            : "Choose Equipment",
        };
        delete updatedDetails.locatedAt;
        delete updatedDetails.locatedAtName;
        delete updatedDetails.mainAsset;
        onDetailsChange(updatedDetails);
        // }
      }
    } else if (field === "mainAssets") {
      if (!isMainAssets) {
        setIsMainAssets(true);
        setIsLocatedAtChecked(false);
        setIsPartOfChecked(false);

        // if (mainAssetsValue && !mainAssetsValue === "") {
        const updatedDetails = {
          ...generalDetails,
          mainAsset: mainAssetsValue,
        };
        delete updatedDetails.partOf;
        delete updatedDetails.partOfName;
        onDetailsChange(updatedDetails);
        // }
      }
    } else if (field === "locatedAt") {
      if (!isLocatedAtChecked) {
        setIsPartOfChecked(false);
        setIsMainAssets(false);
        setIsLocatedAtChecked(true);
        // if (selectFacility) {
        const updatedDetails = {
          ...generalDetails,
          locatedAtName: selectFacility
            ? selectFacility.name
            : "Choose Facility",
        };
        delete updatedDetails.mainAsset;
        onDetailsChange(updatedDetails);
        // }
      }
    }

    // Additional logic if needed
  };

  const [pinCodeForAdress, setPinCodeForAdress] = useState("");

  // postal Code start
  const handleAddressSelect = (address) => {
    const { place_id } = address;
    geocodeByPlaceId(place_id)
      .then((res) => {
        console.log("Found the Address", res);

        if (res && res[0] && res[0].address_components) {
          const { long_name: postalCode = "" } =
            res[0].address_components.find((c) =>
              c.types.includes("postal_code")
            ) || {};
          // setPinCodeForAdress(postalCode);

          if (!address.description.includes(postalCode)) {
            setPinCodeForAdress(postalCode);
          }

          // handleInputChange("mainAsset", address.description + (postalCode ? ', ' + postalCode : ''));

          const { formatted_address, address_components } = res[0];
          // setWorkAddress(formatted_address);
          handleInputChange("mainAsset", formatted_address);
        }
      })
      .catch((err) => {
        console.log("Error while fetching address meta ", err);
      })
      .finally((done) => {
        console.log("Address API Call Completed ", done);
      });
  };
  // postal Code end

  return (
    <>
      <div className="general-tab-wrapper">
        <div className="general-tab-row">
          {assetsType === "Equipment" || assetsType === "Part" ? (
            <Row gutter={16}>
              <Col span={8} className={styles.col_wrap}>
                <div
                  class={`${styles.form_select_popup} ${
                    isPartOfChecked ? "" : styles.diabled
                  } ${
                    validationErrors.partOf &&
                    !generalDetails.partOf &&
                    styles.error
                  }`}
                >
                  <label
                    className={`${styles.form_label} ${styles.form_checkbox_label}`}
                  >
                    {assetsType === "Equipment"
                      ? t("Equipment part of")
                      : t("This is part of")}
                    <div className={styles.custom_radio}>
                      <input
                        type="checkbox"
                        id="partOfCheck"
                        checked={isPartOfChecked}
                        onChange={(e) => handlePartChanges("partOf")}
                      />
                      <span className={styles.checkmark}></span>
                    </div>
                  </label>
                  <div className={styles.form_popup_button}>
                    <button
                      type="button"
                      className={styles.button}
                      onClick={showEquipModal}
                    >
                      {partOfButtonText}
                    </button>
                  </div>
                </div>
                {validationErrors.partOf && !generalDetails.partOf && (
                  <div className="error-message">{validationErrors.partOf}</div>
                )}
                {isQuipPartModal && isPartOfChecked ? (
                  <EquipmentPartListPopup
                    modalOpen={isQuipPartModal}
                    modalHideEv={handleCancel}
                    onSelectEquipmentChange={handleSelectEquipmentChange}
                  />
                ) : (
                  ""
                )}
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>{t("Category")}</label>
                  <div className={styles.input_wrap}>
                    <input
                      type="text"
                      id="category"
                      value={generalDetails?.category}
                      onChange={(e) => {
                        handleInputChange("category", e.target.value);
                        setCategoryArray(e.target.value);
                      }}
                      onFocus={() => {
                        setShowAssetCategoriesList(true);
                      }}
                      // onBlur={() => {
                      //   setShowAssetCategoriesList(false)
                      // }}
                    />
                    {showAssetCategoriesList && (
                      <div>
                        <CategorySelection
                          field={"category"}
                          CategoryList={categories}
                          onClickFunction={handleInputChange}
                          showEffect={setShowAssetCategoriesList}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* <div class={styles.form_select_popup}>
                  <label className={styles.form_label}>Category</label>
                  <div className={styles.custom_form_select}>
                    <Select
                      name="category"
                      showSearch
                      value={{
                        value: generalDetails.category,
                      }}
                      placeholder="Choose a category"
                      optionFilterProp="children"
                      onChange={(value) => handleInputChange("category", value)}
                      filterOption={filterOption}
                      options={categoryListMain}
                    />
                  </div>
                </div> */}
                {/* {validationErrors.category && <div className="error-message">{validationErrors.category}</div>} */}
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div
                  class={`${styles.form_select_popup} ${
                    validationErrors.client &&
                    !generalDetails.client &&
                    styles.error
                  }`}
                >
                  <label className={styles.form_label}>
                    {/* Client */}
                    {t("Client")}
                  </label>
                  <div className={styles.custom_form_select}>
                    <Select
                      name="client"
                      showSearch
                      value={{
                        value:
                          generalDetails.client ===
                          "00000000-0000-0000-0000-000000000000"
                            ? ""
                            : generalDetails.client,
                      }}
                      placeholder="Select Client"
                      optionFilterProp="children"
                      onChange={(value) => handleInputChange("client", value)}
                      filterOption={filterOption}
                      options={clientListMain}
                    />
                  </div>
                </div>
                {validationErrors.client && !generalDetails.client && (
                  <div className="error-message">{validationErrors.client}</div>
                )}
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div
                  class={`${styles.form_select_popup} ${
                    isLocatedAtChecked ? "" : styles.diabled
                  } ${
                    validationErrors.LocatedAt &&
                    !generalDetails.LocatedAt &&
                    styles.error
                  }`}
                >
                  <label
                    className={`${styles.form_label} ${styles.form_checkbox_label}`}
                  >
                    {assetsType === "Equipment"
                      ? t("Equipment location at")
                      : t("Part location at")}
                    <div className={styles.custom_radio}>
                      <input
                        type="checkbox"
                        id="chooseFacility"
                        checked={isLocatedAtChecked}
                        onChange={(e) => handlePartChanges("locatedAt")}
                      />
                      <span className={styles.checkmark}></span>
                    </div>
                  </label>
                  <div className={styles.form_popup_button}>
                    <button
                      type="button"
                      className={styles.button}
                      onClick={showFacilityModal}
                    >
                      {locatedfButtonText}
                    </button>
                  </div>
                </div>
                {validationErrors.LocatedAt && !generalDetails.LocatedAt && (
                  <div className="error-message">
                    {validationErrors.LocatedAt}
                  </div>
                )}
                {showFacilityModal && isLocatedAtChecked ? (
                  <FacilityListPopup
                    modalOpen={isFacilityModal}
                    modalHideEv={handleCancel}
                    isChooseActive={isLocatedAtChecked}
                    onSelectFacilityChange={handleFacilityChange}
                  />
                ) : (
                  ""
                )}
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Barcode */}
                    {t("Barcode")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="number"
                      id="barcode"
                      value={generalDetails?.barcode}
                      onChange={(e) =>
                        handleInputChange("barcode", e.target.value)
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Account (Bookkeeping) */}
                    {t("Account (Bookkiping)")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="number"
                      value={generalDetails?.account}
                      id="accountNum"
                      onChange={(e) =>
                        handleInputChange("account", e.target.value)
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_multi_input_wrap}>
                  <label className={styles.form_label}>
                    {t("Location Specifications")}
                  </label>
                  <div className={styles.inner_input_wrap}>
                    <div className={styles.multiple_input_wrap}>
                      <div className={styles.single_input}>
                        <input
                          type="text"
                          defaultValue={0}
                          value={generalDetails?.aisle}
                          onChange={(e) =>
                            handleInputChange("aisle", e.target.value)
                          }
                        />
                        <label className={styles.input_inner_label}>
                          {/* Aisle */}
                          {t("Aisle")}
                        </label>
                      </div>
                    </div>
                    <div className={styles.multiple_input_wrap}>
                      <div className={styles.single_input}>
                        <input
                          type="text"
                          defaultValue={0}
                          value={generalDetails?.row}
                          onChange={(e) =>
                            handleInputChange("row", e.target.value)
                          }
                        />
                        <label className={styles.input_inner_label}>
                          {/* Row */}
                          {t("Row")}
                        </label>
                      </div>
                    </div>
                    <div className={styles.multiple_input_wrap}>
                      <div className={styles.single_input}>
                        <input
                          type="text"
                          defaultValue={0}
                          value={generalDetails?.bin}
                          onChange={(e) =>
                            handleInputChange("bin", e.target.value)
                          }
                        />
                        <label className={styles.input_inner_label}>
                          {/* Bin */}
                          {t("Bin")}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Serial Number */}
                    {t("Serial Number")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="number"
                      id="serialNum"
                      value={generalDetails?.serialNumber}
                      onChange={(e) =>
                        handleInputChange("serialNumber", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>{t("Model")}</label>
                  <div className={styles.input_wrap}>
                    <input
                      type="text"
                      value={generalDetails?.model}
                      id="modalInput"
                      onChange={(e) => {
                        handleInputChange("model", e.target.value);
                        setModalDataShow(true);
                      }}
                      onFocus={(e) => {
                        setModalDataShow(!modalDataShow);
                      }}
                    />
                  </div>
                  <div className="category-card ">
                    {modalData
                      .filter((item) =>
                        item
                          ?.toLowerCase()
                          .includes(generalDetails?.model.toLowerCase()),
                      )
                      .map((item) => {
                        return (
                          modalDataShow && (
                            <div
                              className="category-item"
                              onClick={() => {
                                handleInputChange("model", item);
                                setModalDataShow(false);
                              }}
                            >
                              {item}
                            </div>
                          )
                        );
                      })}
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div
                  class={`${styles.form_input_wrap} ${styles.textarea_wrap}`}
                >
                  <label className={styles.form_label}>{t("Notes")}</label>
                  <div className={styles.input_wrap}>
                    <textarea
                      id="notesInput"
                      value={generalDetails?.notes}
                      onChange={(e) =>
                        handleInputChange("notes", e.target.value)
                      }
                    ></textarea>
                  </div>
                </div>
              </Col>
            </Row>
          ) : assetsType === "Facility" ? (
            <Row gutter={16}>
              <Col span={8} className={styles.col_wrap}>
                <div
                  class={`${styles.form_select_popup} ${
                    styles.form_textare_wrap
                  } ${isMainAssets ? "" : styles.diabled}`}
                >
                  <label
                    className={`${styles.form_label} ${styles.form_checkbox_label}`}
                  >
                    {/* Main Facility */}
                    {t("Main Facility")}
                    <div className={styles.custom_radio}>
                      <input
                        type="checkbox"
                        id="mainAssetsCheckbox"
                        checked={isMainAssets}
                        onChange={(e) => handlePartChanges("mainAssets")}
                      />
                      <span className={styles.checkmark}></span>
                    </div>
                  </label>
                  <div className={styles.textarea_wrap}>
                    {/* <textarea
                      disabled={!isMainAssets}
                      placeholder="Address"
                      value={generalDetails.mainAsset || ""}
                      onChange={(e) =>
                        handleInputChange("mainAsset", e.target.value)
                      }
                    ></textarea> */}

                    <GooglePlacesAutocomplete
                      disabled={!isMainAssets}
                      debounce={800}
                      renderInput={(props) => (
                        <textarea
                          style={{
                            border: "none",
                            width: "100%",
                            height: "50px",
                            overflow: "hidden",
                          }}
                          {...props}
                          rows={4}
                          placeholder="Address"
                        />
                      )}
                      onSelect={(e) => {
                        handleInputChange("mainAsset", e.description);
                        // setChangeComp(e.description);
                        handleAddressSelect(e);
                      }}
                      placeholder="Address"
                      initialValue={generalDetails.mainAsset || ""}
                      withSessionToken={true}
                    />
                  </div>
                </div>
              </Col>
              <Col
                span={8}
                className={`${styles.col_wrap} ${styles.col_mutiItem_wrap}`}
              >
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>{t("Category")}</label>
                  <div className={styles.input_wrap}>
                    <input
                      type="text"
                      id="category"
                      value={generalDetails?.category}
                      onChange={(e) => {
                        handleInputChange("category", e.target.value);
                        setCategoryArray(e.target.value);
                      }}
                      onFocus={() => {
                        setShowAssetCategoriesList(true);
                      }}
                      // onBlur={() => {
                      //   setShowAssetCategoriesList(false)
                      // }}
                    />
                    {showAssetCategoriesList && (
                      <div>
                        <CategorySelection
                          field={"category"}
                          CategoryList={categories}
                          onClickFunction={handleInputChange}
                          showEffect={setShowAssetCategoriesList}
                        />
                      </div>
                    )}
                  </div>
                </div>
                {/* <div class={styles.form_select_popup}>
                  <label className={styles.form_label}>Category</label>
                  <div className={styles.custom_form_select}>
                    <Select
                      name="category"
                      showSearch
                      value={{
                        value: generalDetails.category,
                      }}
                      placeholder="Choose a category"
                      optionFilterProp="children"
                      onChange={(value) => handleInputChange("category", value)}
                      filterOption={filterOption}
                      options={categoryListMain}
                    />
                  </div>
                </div> */}
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Barcode */}
                    {t("Barcode")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="number"
                      value={generalDetails?.barcode}
                      id="barcode"
                      onChange={(e) =>
                        handleInputChange("barcode", e.target.value)
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col
                span={8}
                className={`${styles.col_wrap} ${styles.col_mutiItem_wrap}`}
              >
                <div class={styles.form_select_popup}>
                  <label className={styles.form_label}>
                    {/* Client */}
                    {t("Client")}
                  </label>
                  <div className={styles.custom_form_select}>
                    <Select
                      showSearch
                      name="client"
                      value={{
                        value:
                          generalDetails.client ===
                          "00000000-0000-0000-0000-000000000000"
                            ? ""
                            : generalDetails.client,
                      }}
                      placeholder="Select Client"
                      optionFilterProp="children"
                      onChange={(value) => handleInputChange("client", value)}
                      filterOption={filterOption}
                      options={clientListMain}
                    />
                  </div>
                </div>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Main Contact */}
                    {t("Main Contact")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="number"
                      id="mainContant"
                      value={generalDetails?.mainContact}
                      onChange={(e) =>
                        handleInputChange("mainContact", e.target.value)
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div
                  class={`${styles.form_select_popup} ${
                    isPartOfChecked ? "" : styles.diabled
                  }`}
                >
                  <label
                    className={`${styles.form_label} ${styles.form_checkbox_label}`}
                  >
                    {/* This facility is part of */}
                    {t("This facility is part of")}
                    <div className={styles.custom_radio}>
                      <input
                        type="checkbox"
                        id="chooseFacility"
                        checked={isPartOfChecked}
                        onChange={(e) => handlePartChanges("partOf")}
                      />
                      <span className={styles.checkmark}></span>
                    </div>
                  </label>
                  <div className={styles.form_popup_button}>
                    <button
                      type="button"
                      className={styles.button}
                      onClick={showFacilityModal}
                    >
                      {partOfButtonText}
                    </button>
                  </div>
                </div>
                {showFacilityModal && isPartOfChecked ? (
                  <FacilityListPopup
                    modalOpen={isFacilityModal}
                    modalHideEv={handleCancel}
                    isChooseActive={isPartOfChecked}
                    onSelectFacilityChange={handleFacilityChange}
                  />
                ) : (
                  ""
                )}
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Account (Bookkeeping) */}
                    {t("Account (Bookkiping)")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="number"
                      value={generalDetails?.account}
                      id="accountNum"
                      onChange={(e) =>
                        handleInputChange("account", e.target.value)
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Serial Number */}
                    {t("Serial Number")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="email"
                      id="Contact Email"
                      value={generalDetails?.contactEmail}
                      placeholder={t("name@example.com")}
                      onChange={(e) =>
                        handleInputChange("contactEmail", e.target.value)
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col span={16} className={styles.col_wrap}>
                <div
                  class={`${styles.form_input_wrap} ${styles.short_textarea} ${styles.textarea_wrap}`}
                >
                  <label className={styles.form_label}>{t("Notes")}</label>
                  <div className={styles.input_wrap}>
                    <textarea
                      id="notesInput"
                      value={generalDetails?.notes}
                      onChange={(e) =>
                        handleInputChange("notes", e.target.value)
                      }
                    ></textarea>
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={`${styles.form_input_wrap} custom-contact-number`}>
                  <label className={styles.form_label}>
                    {/* Contact Telephone */}
                    {t("Contact Telephone")}
                  </label>
                  <div className={styles.input_wrap}>
                    <PhoneInput
                      country={"nl"}
                      enableSearch={true}
                      value={generalDetails?.contactPhone}
                      className="pt-1 contactDeliveryInput ps-4"
                      // placeholder="Contact Telephone"
                      placeholder={t("Contact Telephone")}
                      onChange={(phone) => {
                        handleInputChange("contactPhone", phone);
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            <Row gutter={16}>
              <Col span={8} className={styles.col_wrap}>
                <div
                  class={`${styles.form_select_popup} ${
                    isPartOfChecked ? "" : styles.diabled
                  }`}
                >
                  <label
                    className={`${styles.form_label} ${styles.form_checkbox_label}`}
                  >
                    {t("Equipment part of")}
                    <div className={styles.custom_radio}>
                      <input
                        type="checkbox"
                        id="partOfCheck"
                        checked={isPartOfChecked}
                        onChange={(e) => handlePartChanges("partOf")}
                      />
                      <span className={styles.checkmark}></span>
                    </div>
                  </label>
                  <div className={styles.form_popup_button}>
                    <button
                      type="button"
                      className={styles.button}
                      onClick={showEquipModal}
                    >
                      {partOfButtonText}
                    </button>
                  </div>
                </div>
                {isQuipPartModal && isPartOfChecked ? (
                  <EquipmentPartListPopup
                    modalOpen={isQuipPartModal}
                    modalHideEv={handleCancel}
                    onSelectEquipmentChange={handleSelectEquipmentChange}
                  />
                ) : (
                  ""
                )}
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>{t("Category")}</label>
                  <div className={styles.input_wrap}>
                    <input
                      type="text"
                      id="category"
                      value={generalDetails?.category}
                      onChange={(e) => {
                        handleInputChange("category", e.target.value);
                        setCategoryArray(e.target.value);
                      }}
                      onFocus={() => {
                        setShowAssetCategoriesList(true);
                      }}
                      // onBlur={() => {
                      //   setShowAssetCategoriesList(false)
                      // }}
                    />
                    {showAssetCategoriesList && (
                      <div>
                        <CategorySelection
                          field={"category"}
                          CategoryList={categories}
                          onClickFunction={handleInputChange}
                          showEffect={setShowAssetCategoriesList}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* <div class={styles.form_select_popup}>
                  <label className={styles.form_label}>Category</label>
                  <div className={styles.custom_form_select}>
                    <Select
                      name="category"
                      showSearch
                      value={{
                        value: generalDetails.category,
                      }}
                      placeholder="Choose a category"
                      optionFilterProp="children"
                      onChange={(value) => handleInputChange("category", value)}
                      filterOption={filterOption}
                      options={categoryListMain}
                    />
                  </div>
                </div> */}
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_select_popup}>
                  <label className={styles.form_label}>
                    {/* Client */}
                    {t("Client")}
                  </label>
                  <div className={styles.custom_form_select}>
                    <Select
                      showSearch
                      name="client"
                      value={{
                        value:
                          generalDetails.client ===
                          "00000000-0000-0000-0000-000000000000"
                            ? ""
                            : generalDetails.client,
                      }}
                      placeholder="Select Client"
                      optionFilterProp="children"
                      onChange={(value) => handleInputChange("client", value)}
                      filterOption={filterOption}
                      options={clientListMain}
                    />
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div
                  class={`${styles.form_select_popup} ${
                    isLocatedAtChecked ? "" : styles.diabled
                  }`}
                >
                  <label
                    className={`${styles.form_label} ${styles.form_checkbox_label}`}
                  >
                    {t("Equipment location at")}
                    <div className={styles.custom_radio}>
                      <input
                        type="checkbox"
                        id="chooseFacility"
                        checked={isLocatedAtChecked}
                        onChange={(e) => handlePartChanges("locatedAt")}
                      />
                      <span className={styles.checkmark}></span>
                    </div>
                  </label>
                  <div className={styles.form_popup_button}>
                    <button
                      type="button"
                      className={styles.button}
                      onClick={showFacilityModal}
                    >
                      {locatedfButtonText}
                    </button>
                  </div>
                </div>
                {showFacilityModal && isLocatedAtChecked ? (
                  <FacilityListPopup
                    modalOpen={isFacilityModal}
                    modalHideEv={handleCancel}
                    isChooseActive={isLocatedAtChecked}
                    onSelectFacilityChange={handleFacilityChange}
                  />
                ) : (
                  ""
                )}
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Barcode */}
                    {t("Barcode")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="number"
                      id="barcode"
                      value={generalDetails?.barcode}
                      onChange={(e) =>
                        handleInputChange("barcode", e.target.value)
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Account (Bookkeeping) */}
                    {t("Account (Bookkiping)")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="number"
                      value={generalDetails?.account}
                      id="accountNum"
                      onChange={(e) =>
                        handleInputChange("account", e.target.value)
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_multi_input_wrap}>
                  <label className={styles.form_label}>
                    {t("Location Specifications")}
                  </label>
                  <div className={styles.inner_input_wrap}>
                    <div className={styles.multiple_input_wrap}>
                      <div className={styles.single_input}>
                        <input
                          type="number"
                          value={generalDetails?.aisle}
                          defaultValue={0}
                          onChange={(e) =>
                            handleInputChange("aisle", e.target.value)
                          }
                        />
                        <label className={styles.input_inner_label}>
                          {/* Aisle */}
                          {t("Aisle")}
                        </label>
                      </div>
                    </div>
                    <div className={styles.multiple_input_wrap}>
                      <div className={styles.single_input}>
                        <input
                          type="number"
                          defaultValue={0}
                          value={generalDetails?.row}
                          onChange={(e) =>
                            handleInputChange("row", e.target.value)
                          }
                        />
                        <label className={styles.input_inner_label}>
                          {/* Row */}
                          {t("Row")}
                        </label>
                      </div>
                    </div>
                    <div className={styles.multiple_input_wrap}>
                      <div className={styles.single_input}>
                        <input
                          type="number"
                          defaultValue={0}
                          value={generalDetails?.bin}
                          onChange={(e) =>
                            handleInputChange("bin", e.target.value)
                          }
                        />
                        <label className={styles.input_inner_label}>
                          {/* Bin */}
                          {t("Bin")}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>
                    {/* Serial Number */}
                    {t("Serial Number")}
                  </label>
                  <div className={styles.input_wrap}>
                    <input
                      type="number"
                      value={generalDetails?.serialNumber}
                      id="serialNum"
                      onChange={(e) =>
                        handleInputChange("serialNumber", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div class={styles.form_input_wrap}>
                  <label className={styles.form_label}>{t("Model")}</label>
                  <div className={styles.input_wrap}>
                    <input
                      type="text"
                      value={generalDetails?.model}
                      id="modalInput"
                      onChange={(e) =>
                        handleInputChange("model", e.target.value)
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col span={8} className={styles.col_wrap}>
                <div
                  class={`${styles.form_input_wrap} ${styles.textarea_wrap}`}
                >
                  <label className={styles.form_label}>{t("Notes")}</label>
                  <div className={styles.input_wrap}>
                    <textarea
                      id="notesInput"
                      value={generalDetails?.notes}
                      onChange={(e) =>
                        handleInputChange("notes", e.target.value)
                      }
                    ></textarea>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </>
  );
}

// export default connect(mapStateToProps, mapDispatchToProps)(GroupListPopup);

export default GenralTabContent;
